import { Vector3 } from 'three';

export function calcNormal(v0: Vector3, v1: Vector3, v2: Vector3) {
  const edge1 = v1.clone().sub(v0);
  const edge2 = v2.clone().sub(v0);
  return edge1.cross(edge2).normalize();
}
